@if (initialized) {
    <div class="grid">
        <!-- Import Configs List -->
        <div class="col-12 lg:col-4">
            <div class="card">
                <mvs-widget
                        *ngIf="importConfigsWidget"
                        [widgetData]="importConfigsWidget"
                        (onObjectSelect)="handleImportConfigSelect($event)"
                ></mvs-widget>
            </div>
        </div>

        @if (selectedImportConfig) {
            <!-- Import Config Info -->
            <div class="col-12 lg:col-8">
                <div class="card">
                    <div class="flex align-items-center justify-content-between mb-3">
                        <h5 class="m-0">{{ selectedImportConfig.name }}</h5>
                        <span class="p-tag"
                              [class.p-tag-warning]="selectedImportConfig.status === 0"
                              [class.p-tag-info]="selectedImportConfig.status === 1"
                              [class.p-tag-primary]="selectedImportConfig.status === 2"
                              [class.p-tag-success]="selectedImportConfig.status === 3 || selectedImportConfig.status === 4">
                            @switch (selectedImportConfig.status) {
                                @case (0) { Draft }
                                @case (1) { Mapping Required }
                                @case (2) { Ready for Review }
                                @case (3) { Approved }
                                @case (4) { Exported }
                            }
                        </span>
                    </div>
                    @if (selectedImportConfig.description) {
                        <p class="text-600">{{ selectedImportConfig.description }}</p>
                    }
                    @if (selectedImportConfig.targetObjectType) {
                        <div class="text-sm text-600">
                            <i class="fa-regular fa-bullseye mr-1"></i>
                            Target: {{ selectedImportConfig.targetObjectType }}
                        </div>
                    }
                </div>
            </div>

            <!-- Field Mapping -->
            <div class="col-12 lg:col-8">
                <div class="card">
                    <h5 class="mb-3">Field Mappings</h5>
                    <ea-import-field-mapping-widget
                            [importConfigId]="selectedImportConfig.id"
                    ></ea-import-field-mapping-widget>
                </div>
            </div>

            <!-- Import Preview -->
            <div class="col-12 lg:col-4">
                <div class="card">
                    <h5 class="mb-3">Import Preview</h5>
                    <ea-import-preview-widget
                            [importConfigId]="selectedImportConfig.id"
                    ></ea-import-preview-widget>
                </div>
            </div>
        } @else {
            <div class="col-12 lg:col-8">
                <div class="card">
                    <div class="flex flex-column align-items-center justify-content-center p-6 text-center surface-100 border-round">
                        <i class="fa-regular fa-upload text-4xl text-400 mb-3"></i>
                        <span class="text-600">Select an import configuration to view details</span>
                    </div>
                </div>
            </div>
        }
    </div>
}
